import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=bd4fc144&scoped=true&"
import script from "./Controller.vue?vue&type=script&lang=js&"
export * from "./Controller.vue?vue&type=script&lang=js&"
import style0 from "./Controller.vue?vue&type=style&index=0&id=bd4fc144&prod&lang=scss&scoped=true&"
import style1 from "./Controller.vue?vue&type=style&index=1&id=bd4fc144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4fc144",
  null
  
)

export default component.exports